import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import DashBoardTap from "./DashBoardTap";
import TimeStream from "./TimeStream";
import { useState } from "react";
import moment from "moment";
import { useEffect } from "react";
import { Button } from "@mui/material";
import ButtonAppBar from "../../ButtonAppBar";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ backgroundColor: "#336666" }}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          <DashBoardTap value={value} time={other.time} />
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function DashBoard() {
  const [value, setValue] = React.useState(4);
  const [currentTime, setCurrentTime] = React.useState("");

  const handleTimeUpdate = (time) => {
    setCurrentTime(time);
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    setValue(0);
  }, []);

  const openNewWindow = () => {
    window.open("/sams/dashboardPop");
  };

  return (
    <Box sx={{ width: "100%", marginLeft: 1, marginTop: 8 }}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          display: "flex",
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="WEEK" {...a11yProps(0)} />
          <Tab label="MONTH" {...a11yProps(1)} />
          <Tab label="YEAR" {...a11yProps(2)} />
        </Tabs>
        <Button
          onClick={(e) => {
            e.stopPropagation();
            openNewWindow();
          }}
          size="small"
        >
          Popup
        </Button>
        <TimeStream onTimeUpdate={handleTimeUpdate} value={value} />
        <Typography sx={{ marginLeft: 65, paddingTop: 1.5, fontSize: "13px" }}>
          주간물동량 : 전일 -6일 무게 : Ton
        </Typography>
      </Box>
      <CustomTabPanel
        value={value}
        index={0}
        time={currentTime}
      ></CustomTabPanel>
      <CustomTabPanel
        value={value}
        index={1}
        time={currentTime}
      ></CustomTabPanel>
      <CustomTabPanel
        value={value}
        index={2}
        time={currentTime}
      ></CustomTabPanel>
    </Box>
  );
}
